import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import type { FilterSectionLoadedEvent } from "../multifiltering/FilterTypes";
import { FilterAccordion } from "./FilterAccordion";
import { Filter } from "./Filter";
import { events } from "../events";

const DESKTOP_FILTERS_CLASS = "find_filterList";

export class FilterAccordions {
  private static readonly factory = HeurekaElementFactory.byClass(DESKTOP_FILTERS_CLASS, FilterAccordions);

  /*               */
  constructor(
    private readonly accordionsWrapper: HTMLElement,
    readonly accordions: FilterAccordion[] = FilterAccordion.factory.all(accordionsWrapper),
  ) {}

  /*                  */

  static template(rootElement?: ParentNode | null) {
    return FilterAccordions.factory.pick(undefined, rootElement);
  }

  /*               */

  static register() {
    events.onFilterSectionLoaded(FilterAccordions.initAll);
  }

  static initAll(event: FilterSectionLoadedEvent, rootElement?: ParentNode) {
    FilterAccordions.template(rootElement)?.init();
  }

  protected init() {
    this.updateFeaturesPositions();
    return this;
  }

  /*                       */

  public get values(): HTMLElement[] {
    return this.accordions.map((filterAccordion) => filterAccordion.accordion);
  }

  get filters(): Filter[] {
    return this.accordions.map((accordion) => accordion.filter).filter((filter) => !!filter) as Filter[];
  }

  updateFeaturesPositions() {
    this.filters
      .map((filter) => filter.clearPosition())
      .forEach((filter: Filter, index) => {
        filter.position = index + 1;
      });
  }
}
